import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  supportFormOrderAlreadyRefunded: {
    id: 'supportFormOrderAlreadyRefunded',
    defaultMessage:
      'It looks like you have already received a refund for this order, if you need additional help please reach out below.',
    description: 'Support form text for an order that has already been refunded'
  },
  supportFormRefundGenericError: {
    id: 'supportFormRefundGenericError',
    defaultMessage:
      'We are so sorry you experienced an issue with your order, please describe your issue below.',
    description:
      'Support form text if the user is unable to perform a refund. This is a fallback message.'
  },
  supportFormDeliveryActive: {
    id: 'supportFormDeliveryActive',
    defaultMessage:
      'It looks like your order has not been dropped off yet, if you need additional help please reach out below.',
    description: 'Support form text if a delivery is currently being delivered'
  }
});
